import { Loading } from '@pec/aion-ui-components/components/Loading';
import * as React from 'react';
import { SurveyQuestionElementBase } from 'survey-react-ui';
import { Model, QuestionRadiogroupModel } from 'survey-core';
import { SubscriptionUK } from '../SubscriptionUK';
import { Location } from '../../types/enums';
import { SubscriptionAU } from '../SubscriptionAU';

export const TYPE = 'mui-subscriptions';

export class MuiSubscriptionsModel extends QuestionRadiogroupModel {
  getType(): string {
    return TYPE;
  }

  get productIcons() {
    return this.getPropertyValue('productIcons');
  }

  set productIcons(value) {
    this.setPropertyValue('productIcons', value);
  }
}

export class MuiSubscriptions extends SurveyQuestionElementBase {
  constructor(props: any) {
    super(props);
    this.getLocation = this.getLocation.bind(this);
  }

  get question() {
    return this.questionBase;
  }

  get choices() {
    return this.question.visibleChoices;
  }

  get filterChoicesOnRender() {
    return this.question.filterChoicesOnRender;
  }

  get strings() {
    return this.question.strings;
  }

  get productIcons() {
    return this.question.productIcons;
  }

  getLocation() {
    const model = this.question.survey as Model;
    return model.getVariable('info').location;
  }

  getProductIcon(value: string): string {
    const model = this.question.survey as Model;

    let expression: string = '';
    let result: string = '';

    if (this.productIcons) {
      this.question.productIcons.forEach((element: any) => {
        expression = element.visibleIf.replace(/\{subscriptionTier}/g, `'${value}'`);
        if (model.runExpression(expression)) {
          result = element.iconSrc;
        }
      });
      return result;
    }
    return result;
  }

  protected renderElement(): JSX.Element | null {
    if (this.choices.length === 0) {
      return <Loading />;
    }

    if (this.getLocation() === Location.AU) {
      return (
        <SubscriptionAU
          choices={this.choices}
          strings={this.strings.featuresAU}
          getIcon={this.getProductIcon.bind(this)}
        />
      );
    } else {
      return (
        <SubscriptionUK
          choices={this.choices}
          strings={this.strings.featuresUK}
          getIcon={this.getProductIcon.bind(this)}
        />
      );
    }
  }
}
